export default "__VITE_ASSET__CPH2xjNB__"